import { Component } from "@angular/core";

export class Role {

  public static Admin = 'Admin';
  public static User = 'User';
}
